import * as React from "react";

export default function TwitterIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1340.14 1080.01">
      <path
        d="M716.55,1077.36c498.75,0,771.66-413.6,771.66-771.66,0-11.64,0-23.27-.53-34.91a553.24,553.24,0,0,0,135.08-140.68,549.76,549.76,0,0,1-156,42.84A273,273,0,0,0,1586.26,22.74a539.37,539.37,0,0,1-172.42,65.59C1311.35-20.95,1139.68-26.45,1030.41,76A271.32,271.32,0,0,0,944.71,274a296.75,296.75,0,0,0,6.88,61.88A769.9,769.9,0,0,1,392.87,52.36C321.2,176.44,358,334.83,477,414.65a273.38,273.38,0,0,1-122.7-33.85v3.71a271.69,271.69,0,0,0,217.37,266,272.46,272.46,0,0,1-122.17,4.76,271.14,271.14,0,0,0,253,188.28,543.85,543.85,0,0,1-336.9,116.36,515.38,515.38,0,0,1-64.53-3.7,771.29,771.29,0,0,0,415.18,121.12"
        transform="translate(-289.84 0.01)"
        stroke="#000"
        strokeMiterlimit="52.89"
        strokeWidth="5.29"
      />
    </svg>
  );
}
